import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Gas: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_585)">
                <IconPath
                    d="M13.25 7.22007H15.25C16.05 7.22007 16.75 7.92007 16.75 8.72007V21.4201C16.75 22.3201 17.35 23.1201 18.25 23.2201C19.35 23.4201 20.25 22.5201 20.25 21.5201V4.92007C20.25 3.62007 20.95 2.32007 22.05 1.62007L23.25 0.820068M20.25 6.71997H21.75M0.753906 11.2363H13.25M13.25 22.2363C13.25 22.8363 12.85 23.2363 12.25 23.2363H1.75C1.15 23.2363 0.75 22.8363 0.75 22.2363V3.23633C0.75 2.63633 1.15 2.23633 1.75 2.23633H12.25C12.85 2.23633 13.25 2.63633 13.25 3.23633V22.2363ZM10.5 6.73633C10.5 5.93633 9.8 5.23633 9 5.23633H5C4.2 5.23633 3.5 5.93633 3.5 6.73633C3.5 7.53633 4.2 8.23633 5 8.23633H9C9.8 8.23633 10.5 7.53633 10.5 6.73633Z"
                    strokeMiterlimit="10"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_585">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
